import { render, staticRenderFns } from "./EditAssociatedProject.vue?vue&type=template&id=5c689d7f"
import script from "./EditAssociatedProject.vue?vue&type=script&lang=js"
export * from "./EditAssociatedProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports